import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteMembership } from '../../../../_global/fragments/generated/CompleteMembership';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteMembershipMutationVariables = Types.Exact<{
  input: Types.DeleteMembershipInput;
  locale?: Types.InputMaybe<Types.SupportedLocale>;
}>;


export type DeleteMembershipMutation = { __typename?: 'Mutation', deleteMembership?: { __typename?: 'DeleteMembershipPayload', membership?: { __typename?: 'Membership', id: string, type: string, accountUser?: { __typename?: 'AccountUser', accountUserType?: Types.AccountUserTypeEnum | null, avatarColor?: Types.AvatarColor | null, email?: string | null, id: string, inviteEmailAddress?: string | null, isPending: boolean, name?: string | null, profileImageUrl?: string | null, userId?: string | null, licenseType?: Types.AccountUserLicenseTypeValue | null } | null, accountUserGroup?: { __typename?: 'AccountUserGroup', accountId: string, emoji?: string | null, id: string, memberCount?: number | null, name?: string | null } | null, role?: { __typename?: 'Role', description?: string | null, id: string, name: string, order?: number | null } | null } | null } | null };


export const DeleteMembership = /*#__PURE__*/ gql`
    mutation DeleteMembership($input: DeleteMembershipInput!, $locale: SupportedLocale) {
  deleteMembership(input: $input) {
    membership {
      ...CompleteMembership
    }
  }
}
    ${CompleteMembership}` as unknown as DocumentNode<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

          

          export const useDeleteMembershipMutation = (options?:MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>) => useMutation(DeleteMembership, options);
          

          export type DeleteMembershipMutationOptions = MutationHookOptions<DeleteMembershipMutation, DeleteMembershipMutationVariables>;

          

          export type DeleteMembershipMutationResult = ReturnType<typeof useDeleteMembershipMutation>[1];

          
